<template>
  <div class="plv-iar-product__list-loading">
    <icon-loading class="plv-iar-product__list-loading__icon" />
    <div v-if="text" class="plv-iar-product__list-loading__text">{{ text }}</div>
  </div>
</template>

<script>
import { IconLoading } from '@/icon-components/map';
export default {
  components: {
    IconLoading,
  },

  props: {
    text: String,
  },
};
</script>

<style lang="scss">
.plv-iar-product__list-loading {
  color: rgba(255, 255, 255, .3);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.plv-iar-product__list-loading__icon {
  font-size: 32px;
  animation: spin 1s ease infinite;
  margin-bottom: 8px;
  display: flex;
}
</style>
